import { Component, OnInit } from '@angular/core';
import {AuthService, ChessComUserData, UserData} from '../auth.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../alert.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass']
})


export class DashboardComponent implements OnInit {

  user: firebase.User;
  script: any;
  message: string;
  users: UserData[]
  coin: number
  chessComNamePlayer?: string
  chesscomuser: ChessComUserData
  toggleEvent = false

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    public alert: AlertService,
    private chesscom: HttpClient,
    private router: Router) { }

  ngOnInit() {
    this.auth.getUserState()
      .subscribe(user => {
        this.user = user;
        if (!this.user) {
          this.router.navigate(['/login'], {
            queryParams: {
              loginAgain: true
            }
          });
        }
      });
    this.auth.getUsers().subscribe(users => {
      this.users = users
      for (let u of users ) {
        if (this.user.email === u.email) {
          this.coin = u.coin;
          this.chessComNamePlayer = u.chessComName;
          this.chesscom.get<ChessComUserData>(`https://api.chess.com/pub/player/${this.chessComNamePlayer}`)
            .subscribe(chesscomuser => {
              this.chesscomuser = chesscomuser
              console.log(chesscomuser);
            });
        }
      }
    });

  }

  logout() {
    this.auth.logout();
    this.alert.warning('Вы вышли из системы');
  }
}
